import { useCallback, useState } from "react";
import { api, extractErrorMessage } from "../../../../util/api";
import { LoadingButton } from "../../../../components/LoadingButton";

export const RerunSuperDialParser = ({ onRun, ...rest }) => {
  const [_error, setError] = useState(null);
  const [running, setRunning] = useState(false);

  const handleRerun = useCallback(async () => {
    setRunning(true);

    try {
      const res = await api.get("/admin/auto_status_parsing_settings/rerun_super_dial_parser");

      if (onRun) {
        onRun(res.data?.meta?.message, res.data?.meta?.error_details);
      }
    } catch (err) {
      setError(extractErrorMessage(err));
    } finally {
      setRunning(false);
    }
  }, [onRun]);

  return (
    <>
      <LoadingButton loading={running} onClick={handleRerun} {...rest}>
        Rerun SuperDial Parser
      </LoadingButton>
    </>
  );
};
